var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from '../../../interface/IVueDialog';
import AccountService from '../../../api/AccountService';
var MyRightDialog = (function (_super) {
    __extends(MyRightDialog, _super);
    function MyRightDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = {
            privileges: [],
        };
        return _this;
    }
    MyRightDialog.prototype.created = function () {
        var _this = this;
        this.accountService = AccountService.getInstance();
        this.accountService
            .getPrivilege()
            .then(function (res) {
            _this.data = res.data.data;
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    MyRightDialog.prototype.confirm = function () {
        this.$closeDialog();
    };
    MyRightDialog = __decorate([
        Component({
            computed: {
                percentage: function () {
                    if (this.data.next_point) {
                        return (this.data.total_point / this.data.next_point) * 100;
                    }
                    return 0;
                },
            },
        })
    ], MyRightDialog);
    return MyRightDialog;
}(VueDialog));
export default MyRightDialog;
